/**
 * ============================================================================
 * СЕРВИС FAQ
 * ============================================================================
 * Методы для работы с часто задаваемыми вопросами
 * ============================================================================
 */

import api from './api'

export const faqService = {
	/**
	 * Получить все FAQ курса
	 */
	async getByCourseId(courseId) {
		const response = await api.get(`/courses/${courseId}/faq`)
		return response.data
	},

	/**
	 * Получить FAQ по ID
	 */
	async getById(id) {
		const response = await api.get(`/faq/${id}`)
		return response.data
	},

	/**
	 * Создать новый FAQ
	 */
	async create(courseId, faqData) {
		const response = await api.post(`/courses/${courseId}/faq`, faqData)
		return response.data
	},

	/**
	 * Обновить FAQ
	 */
	async update(id, faqData) {
		const response = await api.put(`/faq/${id}`, faqData)
		return response.data
	},

	/**
	 * Удалить FAQ
	 */
	async delete(id) {
		const response = await api.delete(`/faq/${id}`)
		return response.data
	},

	/**
	 * Опубликовать FAQ
	 */
	async publish(id) {
		const response = await api.post(`/faq/${id}/publish`)
		return response.data
	},

	/**
	 * Снять с публикации
	 */
	async unpublish(id) {
		const response = await api.post(`/faq/${id}/unpublish`)
		return response.data
	},

	/**
	 * Изменить порядок FAQ
	 */
	async reorder(courseId, faqIds) {
		const response = await api.post(`/courses/${courseId}/faq/reorder`, {
			faqIds,
		})
		return response.data
	},
}

export default faqService

